import { Dialog, DialogContent, IconButton, Box, useMediaQuery, useTheme } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import AgentTicketDetail from '../../pages/agent/TicketDetail'

interface TicketDetailModalProps {
  open: boolean
  ticketId: string | null
  onClose: () => void
  onUpdate?: () => void // Callback to refresh ticket list after updates
}

export function TicketDetailModal({ open, ticketId, onClose, onUpdate }: TicketDetailModalProps) {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  if (!ticketId) return null

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          minHeight: fullScreen ? '100vh' : '80vh',
          maxHeight: fullScreen ? '100vh' : '90vh',
        }
      }}
    >
      <Box sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0, overflow: 'auto' }}>
        <Box sx={{ p: 3 }}>
          <AgentTicketDetail
            ticketId={ticketId}
            isModal={true}
            onClose={onClose}
            onUpdate={onUpdate}
          />
        </Box>
      </DialogContent>
    </Dialog>
  )
}
